import { useNavigate } from "react-router-dom";
import { SelectOption } from "components/dropdown/Dropdown";
import { ActionLinkConfig } from "components/helpers/CustomFieldRenderers/SearchListFieldRenderer/SearchListRenderer";
import { ACTION_KEY, APP_ROUTES, FILTER_KEY, endpoints } from "config";

export const endpointConfig = {
  programmeID: endpoints.workflowConfiguration.search.programmes,
  milestonesID: endpoints.workflowConfiguration.search.milestones,
  tasksID: endpoints.workflowConfiguration.search.tasks,
};

export const linkConfig: ActionLinkConfig = {
  programmeID: {
    text: "View programme",
    permissionKey: "view",
    location: APP_ROUTES.programmes,
  },
};

export const actionLinkTextConfig = {
  programmeID: {
    text: "Add new programme",
    permissionKey: "create",
    location: "/programmes",
  },
};

export const onLinkClick = <T,>(field: keyof T, option: SelectOption) => {
  const navigate = useNavigate();
  let filterString = "";
  let route = "";

  switch (field) {
    case "programmeID":
      filterString = `Programmes__Id EQ (${option.value})`;
      route = APP_ROUTES.programmes;
      break;
  }

  window.localStorage.setItem(FILTER_KEY, filterString);
  navigate(route)
};
export const onActionLinkClick = <T,>(field: keyof T) => {
  const navigate = useNavigate();
  let action = "";
  let route = "";

  switch (field) {
    case "programmeID":
      route = APP_ROUTES.programmes;
      action = "CREATE";
      break;
  }

  window.localStorage.setItem(ACTION_KEY, action);
  navigate(route);
};
